<template>
  <b-card no-body class="w-100 entryWrapper">
    <b-card-header header-tag="header" class="p-1" role="tab">
      <div id="cardTitle">
        <b-button
          ref="toggleButton"
          :class="visible ? null : 'collapsed'"
          :aria-expanded="visible ? 'true' : 'false'"
          :aria-controls="accordionId"
          block
          @click="visible = !visible"
        >
          <i class="bi bi-caret-right-fill"></i>
        </b-button>

        <div class="titleOfTheCard">
          {{ titleOfTheCard }}
        </div>
      </div>
    </b-card-header>
    <b-collapse :id="accordionId" v-model="visible" invisible accordion="my-accordion" role="tabpanel">
      <b-card-body> <peer-review-entry-content :targeted-user-id="userId"></peer-review-entry-content> </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import mapGettersMixin from '../../mixins/mapGettersMixin'
import PeerReviewEntryContent from './PeerReviewEntryContent.vue'

export default {
  name: 'PeerReviewTeamMember',
  components: { PeerReviewEntryContent },
  mixins: [mapGettersMixin],
  props: {
    titleOfTheCard: String,
    userId: Number
  },
  data() {
    return {
      visible: true,
      accordionId: 'bsp',
      localeConsts: {}
    }
  }
}
</script>

<style>
b-card {
  width: inherit;
}

.entryWrapper {
  margin-bottom: 60px !important;
}

#title {
  color: #8b69a9;
}

#cardTitle {
  display: inline-flex;
  align-content: space-around;
}

.titleOfTheCard {
  display: flex;
  width: 195px;
  justify-content: space-between;
  align-items: center;
  margin-left: 10px;
}
</style>
